module.exports = __webpack_public_path__ + "img/flow-05.bc8bc7ab.jpg";